import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit'
import { getRouteEstimates } from '@/components/RoutePreview/RouteRequest';
import { BookingPayload, initialState } from './bookingReducer.types';
import { BASE_URL } from '@/Routes';


const decodeRoute = (r: any) => ({
    ...r,
    path:
        window.google.maps.geometry.encoding
            .decodePath(r.polyline)
            .map((p: any) => ({
                lat: p.lat(),
                lng: p.lng(),
            })),
})


export const fetchRoutes = createAsyncThunk("booking/fetchRoutes",
    async (booking: BookingPayload, thunkAPI) => {

        try {

            // probs need changing, to send select id as well 

            const estimate = await getRouteEstimates(booking);

            const cacheId = estimate.id

            const decodedRoutes = estimate.routes.map(decodeRoute);

            const newBooking = estimate.bookingRequest

            return { decodedRoutes, cacheId, newBooking };

        } catch (err: any) {

            return thunkAPI.rejectWithValue(
                err.message || "Failed to fetch routes"
            );
        }
    }
);

export const rehydrateBooking = createAsyncThunk("booking/rehydrateBooking",
    async (id: string, thunkAPI) => {

        const link = `${BASE_URL}/rehydrate/${id}`;

        try {
            const response = await fetch(link);

            const data = await response.json();

            const decodedRoutes = data.routes.map(decodeRoute);


            return {
                cacheId: data.id,
                booking: data.bookingRequest,
                routes: decodedRoutes,


            };
        } catch (err: any) {
            return thunkAPI.rejectWithValue(
                err.message || "Failed to restore session please start a new Search "
            )
        }
    }
);

export const bookingSlice = createSlice({
    name: 'bookingDetails',

    initialState,

    reducers: {

        setBooking: (
            state,
            action: PayloadAction<BookingPayload>
        ) => {
            state.booking = action.payload;
        },

        setRouteSelectedId: (
            state,
            action: PayloadAction<string>
        ) => {
            state.booking.routeSelectedId = action.payload
        },

        clearBooking: () => initialState,

    },

    extraReducers: (builder) => {

        builder

            // ============================
            // FETCH ROUTES - PENDING
            // ============================

            .addCase(
                fetchRoutes.pending,

                (state) => {

                    state.loading = true;
                    state.error = null;
                }
            )

            // ============================
            // FETCH ROUTES - SUCCESS
            // ============================

            .addCase(
                fetchRoutes.fulfilled,

                (state, action) => {

                    state.routes = action.payload.decodedRoutes
                    state.booking = action.payload.newBooking
                    state.cacheId = action.payload.cacheId
                    state.loading = false;
                }
            )

            // ============================
            // FETCH ROUTES - ERROR
            // ============================

            .addCase(
                fetchRoutes.rejected,

                (state, action) => {

                    state.loading = false;

                    state.error =
                        (action.payload as string) ||
                        "Something went wrong";
                }
            )

            .addCase(
                rehydrateBooking.fulfilled,
                (state, action) => {
                    state.booking = action.payload.booking;
                    state.routes = action.payload.routes;
                    state.cacheId = action.payload.cacheId
                }
            )

            ////////////

            .addCase(
                rehydrateBooking.pending,
                state => {
                    state.loading = true;
                }
            )



            .addCase(
                rehydrateBooking.rejected,
                state => {
                    state.loading = false;
                }
            )


    },
})

export const { setBooking, clearBooking, setRouteSelectedId } = bookingSlice.actions

// Other code such as selectors can use the imported `RootState` type


export default bookingSlice.reducer


